    import PropTypes from "prop-types";
import React from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import classes from "./PreviewTable.module.css";
import TablePagination from "@material-ui/core/TablePagination";
import PreviewTableHeader from "./PreviewTableHeader/PreviewTableHeader";
import PreviewTableBody from "./PreviewTableBody/PreviewTableBody";

function PreviewTable(props) {
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table}
                           aria-labelledby="tableTitle"
                           size={"medium"}
                           aria-label="enhanced table">
                        <PreviewTableHeader
                            handleSort={props.handleSort}
                            headElements={props.tableHeaderItems}
                            isAscending={props.isAscending}
                            orderBy={props.orderBy}/>
                        <PreviewTableBody
                            handleTakingRows={props.handleTakingRows}
                            itemsCount={props.itemsCount}
                            currentPage={props.currentPage}
                            handleSkippingRows={props.handleSkippingRows}
                            rowsPerPage={props.rowsPerPage}
                            preparedTableData={props.preparedTableData}/>
                    </Table>
                </TableContainer>
                {props.hidePagination === true ? <></> : <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={props.itemsCount}
                    rowsPerPage={props.rowsPerPage}
                    page={props.currentPage}
                    onPageChange={props.handleSkippingRows}
                    onRowsPerPageChange={props.handleTakingRows}
                />}
            </Paper>
        </div>
    );
}

PreviewTable.propTypes = {
    currentPage: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    itemsCount: PropTypes.number.isRequired,

    tableHeaderItems: PropTypes.array.isRequired,
    preparedTableData: PropTypes.array.isRequired,
    orderBy: PropTypes.string,
    isAscending: PropTypes.bool.isRequired,

    handleSort: PropTypes.func.isRequired,
    handleTakingRows: PropTypes.func.isRequired,
    handleSkippingRows: PropTypes.func.isRequired,

    hidePagination: PropTypes.bool
}

export default PreviewTable;